import { render, staticRenderFns } from "./AddSenderID.vue?vue&type=template&id=ec91e428&scoped=true"
import script from "./AddSenderID.vue?vue&type=script&lang=js"
export * from "./AddSenderID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec91e428",
  null
  
)

export default component.exports